{
 "_about": "Shared by scripts/emotion_measure.py (measures the archive) and src/situations.js (detects the live scene). Flags: case-insensitive. Edit here only.",
 "situations": {
  "cries": {
   "label": "when they cry or break down",
   "re": "\\b(cr(?:y|ies|ied|ying)|tears?|sob(?:s|bed|bing)?|weep\\w*|breaks? down|broke down)\\b"
  },
  "teases": {
   "label": "when they tease or joke",
   "re": "\\b(teas\\w+|jok\\w+|smirk\\w*|grin\\w*|playful\\w*|wink\\w*|snicker\\w*|giggl\\w*)\\b"
  },
  "angry": {
   "label": "when they snap or get angry",
   "re": "\\b(snap(?:s|ped)|glar\\w+|growl\\w*|shout\\w*|yell\\w*|furious|angry|anger|slam(?:s|med)|snarl\\w*|fum\\w+|seeth\\w+)\\b"
  },
  "afraid": {
   "label": "when they are afraid",
   "re": "\\b(afraid|scared|terrified|fear\\w*|trembl\\w*|shak(?:es|ing|y) (?:hands?|voice)|(?:hands?|voice) (?:shak(?:es|ing|y)|trembl\\w*)|panic\\w*|flinch\\w*)\\b"
  },
  "hurt": {
   "label": "when they are hurt, sick or in pain",
   "re": "\\b(wound\\w*|bleed\\w*|blood|injur\\w*|hurt|sick|fever|ill\\b|pain|winc\\w+|limp\\w*|bruis\\w*|faint\\w*|collaps\\w*)\\b"
  },
  "apologizes": {
   "label": "when they apologize",
   "re": "\\b(sorry|apolog\\w+|forgive me|my fault)\\b"
  },
  "refuses": {
   "label": "when they refuse or defy",
   "re": "\\b(refus\\w+|won't|will not|i'm not going to|you can't make me|defian\\w*|disobey\\w*|i said no|not happening)\\b"
  },
  "declares_love": {
   "label": "when they say they love them",
   "re": "\\b(i love you|love you|i'm in love|i am in love)\\b"
  },
  "touches": {
   "label": "when they kiss or hold them",
   "re": "\\b(kiss\\w*|hug(?:s|ged|ging)?|embrac\\w+|holds? (?:his|her|their) hand|cuddl\\w*|nuzzl\\w*|wraps? (?:his|her|their) arms|snuggl\\w*)\\b"
  },
  "leaves": {
   "label": "when they walk away or pull back",
   "re": "\\b(walks? away|walked away|leav(?:es|ing)|left the room|pulls? away|pulled away|turns? away|turned away|storm(?:s|ed) (?:off|out)|steps? back|stepped back)\\b"
  },
  "quiet": {
   "label": "when they go quiet",
   "re": "\\b(silent|silence|quiet\\w*|doesn't answer|says nothing|said nothing|looks? away|looked away|avoid\\w* (?:his|her|their) eyes)\\b"
  },
  "flirts": {
   "label": "when they flirt",
   "re": "\\b(flirt\\w*|bites? (?:her|his) lip|sultry|seductive\\w*|purr\\w*|coy|bats? (?:her|his) (?:eyes|lashes))\\b"
  },
  "begs": {
   "label": "when they beg or plead",
   "re": "\\b(please|beg(?:s|ged|ging)?|plead\\w*)\\b"
  },
  "thanks": {
   "label": "when they thank or compliment them",
   "re": "\\b(thank you|thanks|you're (?:amazing|wonderful|beautiful|handsome|incredible)|so (?:kind|good) to me)\\b"
  },
  "jealous": {
   "label": "when someone else is close to them",
   "re": "\\b(jealous\\w*|another (?:man|woman)|flirting with|his arm around her|her hand on his|other (?:guy|girl|man|woman)|ex\\b)\\b"
  },
  "lies": {
   "label": "when they lie or are caught out",
   "re": "\\b(lie[sd]?|lying|liar|caught|the truth|honest with me|hiding something)\\b"
  },
  "drunk": {
   "label": "when they are drunk or reckless",
   "re": "\\b(drunk|wasted|tipsy|reckless|hungover)\\b"
  },
  "needs_help": {
   "label": "when they ask for help or protection",
   "re": "\\b(help me|please help|need (?:your|his|her) help|can you help|protect me|save me|keep me safe)\\b"
  },
  "challenges": {
   "label": "when they challenge or provoke them",
   "re": "\\b(dare you|prove it|make me|try me|is that a threat|you wouldn't|bet you|coward|challeng\\w*|provok\\w*)\\b"
  },
  "asks": {
   "label": "when they ask something",
   "re": "\\?"
  }
 },
 "responses": {
  "asks a question": {
   "re": "\\?"
  },
  "explains or reasons": {
   "re": "\\b(because|the reason|let me explain|you see|that is why|that's why|which is why|the point is)\\b"
  },
  "commands": {
   "re": "(?:^|[.!?]\\s+)(?:[\\w' ]{0,12}, )?(look at me|come here|sit|stay|stop|go|listen|lie down|lie back|be quiet|hush|quiet|tell me|show me|answer me|don't|do not|leave|get out|get up|wait|kneel|say it|drink|eat|sleep|rest|breathe)\\b"
  },
  "deflects or changes the subject": {
   "re": "\\b(anyway|never ?mind|forget it|that's not important|let's not|another time|we'll talk later|drop it|moving on)\\b"
  },
  "apologizes": {
   "re": "\\b(sorry|apolog\\w+|forgive me|my fault)\\b"
  },
  "reassures": {
   "re": "\\b(it(?:'s| is| will be|'ll be) (?:all ?right|okay|fine)|i'm here|i am here|i've got you|i have you|you're safe|you are safe|don't worry|do not worry|shh+|hush|i won't let|i will not let|nothing will happen|you are not alone|you're not alone)\\b"
  },
  "agrees or gives in": {
   "re": "\\b(fine\\.|very well|as you wish|as you say|alright then|all right then|if you insist|i suppose so|you win|have it your way|if you must)\\b"
  },
  "refuses": {
   "re": "\\b(no\\.|i won't|i will not|absolutely not|out of the question|never\\.|not a chance)\\b"
  },
  "threatens or warns": {
   "re": "\\b(threat\\w*|warn\\w*|or else|i will (?:kill|end|destroy|ruin)|don't make me|do not make me|you'll regret|you will regret)\\b"
  },
  "says i love you": {
   "re": "\\b(i love you)\\b"
  },
  "teases back": {
   "re": "\\b(teas\\w+|mr\\.? cat|little mouse|is that so|oh\\?|are you now|do you now|i'm sure|cute)\\b"
  }
 }
}
